import 'select2';
import BaseFilter from '../modules/filters/baseFilter';

class ReportSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.select = this.root.querySelector('.periodic-report__select');
        this.tables = this.root.querySelectorAll('.periodic-report__item');
        this.activeTable = Array.from(this.tables).filter(
            item => !item.classList.contains('-hide')
        );
        this.timelines = this.root.querySelectorAll(
            '.periodic-report__timeline'
        );

        this.selectInstance = null;
        this.filterSwitcherInstances = [];

        return true;
    }

    init() {
        this.setSelectInstance();
        this.setFilterSwitcherInstances();
        this.handleSelectListener();
    }

    setSelectInstance() {
        this.selectInstance = $(this.select).select2({
            width: '100%',
        });
    }

    setFilterSwitcherInstances() {
        if (!this.timelines || this.timelines.length === 0) return false;

        this.timelines.forEach(item => {
            const filterSwitcher = new BaseFilter(item, this.root);
            this.filterSwitcherInstances.push(filterSwitcher);
        });

        this.root.addEventListener('filter-switcher-change', event => {
            this.handleYearChange(event);
        });
    }

    handleSelectListener() {
        if (!this.selectInstance) return false;
        const tables = this.tables;
        const that = this;
        this.selectInstance.on('select2:select', function (e) {
            const choosenTable = this.options[this.selectedIndex].value;

            that.filterSwitcherInstances.forEach(item => {
                item.toggleClick(0);
            });

            tables.forEach(item => {
                item.classList.add('-fade-out');

                setTimeout(() => {
                    item.classList.add('-hide');
                    const activeButtons = that.root.querySelectorAll(
                        '.filter-switcher__button.active'
                    );

                    if (activeButtons?.length > 0) {
                        activeButtons.forEach(button => button.click());
                    }
                }, 400);
            });

            setTimeout(() => {
                tables[choosenTable].classList.remove('-hide');

                setTimeout(() => {
                    tables[choosenTable].classList.remove('-fade-out');
                }, 50);

                that.activeTable = Array.from(that.tables).filter(
                    item => !item.classList.contains('-hide')
                );
            }, 400);
        });
    }

    handleYearChange(e) {
        const { value } = e.detail;
        const bodyTrs = this.activeTable[0].querySelectorAll('tbody tr');
        const trToShow = this.activeTable[0].querySelector(
            `[data-year="${value}"]`
        );

        if (trToShow) {
            bodyTrs.forEach(item => item.classList.add('-hide'));
            trToShow.classList.remove('-hide');
        } else {
            bodyTrs.forEach(item => item.classList.remove('-hide'));
        }
    }
}

const sections = document.querySelectorAll('.periodic-report');
const initReportsSections = sections => {
    if (sections) {
        sections.forEach(section => new ReportSection(section));
    }
};

initReportsSections(sections);
